import { LOGO_SVG } from './Logo';

export const Icons = {
  Search: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
    </svg>
  ),

  Plus: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v14m7-7H5" />
    </svg>
  ),

  Copy: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  ),

  Download: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),

  FileSpreadsheet: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17h6l3 3v-3h2V4H4v13h2v3l3-3z" />
    </svg>
  ),

  Swap: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <polyline strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                points="17,1 21,5 17,9" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M21,5 L3,5" />
      <polyline strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                points="7,23 3,19 7,15" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M21,19 L3,19" />
    </svg>
  ),

  Trash2: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h18m-2 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
    </svg>
  ),

  Edit3: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),

  Save: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
    </svg>
  ),

  X: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),

  Eye: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),

  Upload: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
  ),

  Loader: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3.5" />
      <path
        className="opacity-90"
        d="M12 3a9 9 0 0 1 9 9"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  ),

  GoogleDrive: ({ className }) => (
    <svg className={className} viewBox="0 0 800 741.3696" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="google-drive-mask" width="168" height="154" x="12" y="18" maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          d="M63.09 37c14.626-25.333 51.193-25.334 65.819 0l45.033 78c14.626 25.334-3.657 57.001-32.91 57.001H50.967c-29.253 0-47.536-31.667-32.91-57.001Z"
        />
      </mask>
      <g mask="url(#google-drive-mask)" transform="matrix(4.8140532,0,0,4.8140532,-62.146701,-86.652356)">
        <path fill="url(#google-drive-grad-b)" d="M206.905 172.02h-91.888l-19.015-32.934 45.944-79.578Z" />
        <path fill="url(#google-drive-grad-c)" d="M-14.919 172.006 50.04 59.494v.002L31.032 92.422h38.02L115 172.004l-129.918.001Z" />
        <path fill="url(#google-drive-grad-d)" d="M96.007-20.085 141.954 59.5l-19.011 32.928H31.048Z" />
      </g>
      <defs>
        <linearGradient id="google-drive-grad-b" x1="193.6" x2="103.09" y1="165.6" y2="111.21" gradientUnits="userSpaceOnUse">
          <stop offset=".09" stopColor="#ffe921" />
          <stop offset="1" stopColor="#fec700" />
        </linearGradient>
        <linearGradient id="google-drive-grad-c" x1="114.4" x2="15.53" y1="181.61" y2="121.8" gradientUnits="userSpaceOnUse">
          <stop offset=".15" stopColor="#a9a8ff" />
          <stop offset=".33" stopColor="#6d97ff" />
          <stop offset=".48" stopColor="#3186ff" />
        </linearGradient>
        <linearGradient id="google-drive-grad-d" x1="128.88" x2="28.7" y1="37.88" y2="84.64" gradientUnits="userSpaceOnUse">
          <stop offset=".55" stopColor="#0ebc5f" />
          <stop offset=".85" stopColor="#78c9ff" />
        </linearGradient>
      </defs>
    </svg>
  ),

  Mega: ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 361.4 361.4">
      <path
        fill="#d9272e"
        d="M180.7 0C80.9 0 0 80.9 0 180.7c0 99.8 80.9 180.7 180.7 180.7 99.8 0 180.7-80.9 180.7-180.7C361.4 80.9 280.5 0 180.7 0Zm93.8 244.6c0 3.1-2.5 5.6-5.6 5.6h-23.6c-3.1 0-5.6-2.5-5.6-5.6v-72.7c0-.6-.7-.9-1.2-.5l-50 50c-4.3 4.3-11.4 4.3-15.7 0l-50-50c-.4-.4-1.2-.1-1.2.5v72.7c0 3.1-2.5 5.6-5.6 5.6H92.4c-3.1 0-5.6-2.5-5.6-5.6V116.8c0-3.1 2.5-5.6 5.6-5.6h16.2c2.9 0 5.8 1.2 7.9 3.3l62.2 62.2c1.1 1.1 2.8 1.1 3.9 0l62.2-62.2c2.1-2.1 4.9-3.3 7.9-3.3h16.2c3.1 0 5.6 2.5 5.6 5.6v127.8z"
      />
    </svg>
  ),

  Wire: ({ className = '' }) => (
    <svg className={className} width={24} height={24} viewBox="0 0 512 512" fill="none">
      <g>
        <path d="M220.885,106.105c-5.078,0-9.578-3.641-10.492-8.82l-11.109-63.021c-1.023-5.805,2.852-11.335,8.648-12.359c5.805-1.023,11.335,2.852,12.359,8.656l11.108,63.021c1.023,5.805-2.851,11.335-8.647,12.359C222.127,106.05,221.502,106.105,220.885,106.105z" fill="#434A54" />
        <path d="M291.101,106.105c-0.609,0-1.234-0.055-1.859-0.164c-5.812-1.023-9.687-6.554-8.656-12.359l11.109-63.021c1.016-5.804,6.546-9.679,12.358-8.656c5.797,1.023,9.671,6.554,8.656,12.359l-11.125,63.021C300.679,102.464,296.179,106.105,291.101,106.105z" fill="#434A54" />
        <path d="M255.992,85.324c-5.891,0-10.664-4.773-10.664-10.664V10.663C245.328,4.772,250.101,0,255.992,0c5.891,0,10.665,4.772,10.665,10.663V74.66C266.657,80.551,261.884,85.324,255.992,85.324z" fill="#434A54" />
        <path d="M277.337,63.997h-42.68c-5.89,0-10.663,4.773-10.663,10.664v234.656c0,5.89,4.773,10.671,10.663,10.671h42.68c5.874,0,10.655-4.781,10.655-10.671V74.66C287.992,68.77,283.211,63.997,277.337,63.997z" fill="#A0D468" />
      </g>
    </svg>
  ),

  DragHandle: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
      <path d="M7 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
    </svg>
  ),

  Cable: ({ className = '', style }) => (
    <svg className={className} style={style} width={24} height={24} viewBox="0 0 512 512" fill="currentColor">
      <g>
        <path d="M220.885,106.105c-5.078,0-9.578-3.641-10.492-8.82l-11.109-63.021c-1.023-5.805,2.852-11.335,8.648-12.359c5.805-1.023,11.335,2.852,12.359,8.656l11.108,63.021c1.023,5.805-2.851,11.335-8.647,12.359C222.127,106.05,221.502,106.105,220.885,106.105z" />
        <path d="M291.101,106.105c-0.609,0-1.234-0.055-1.859-0.164c-5.812-1.023-9.687-6.554-8.656-12.359l11.109-63.021c1.016-5.804,6.546-9.679,12.358-8.656c5.797,1.023,9.671,6.554,8.656,12.359l-11.125,63.021C300.679,102.464,296.179,106.105,291.101,106.105z" />
        <path d="M255.992,85.324c-5.891,0-10.664-4.773-10.664-10.664V10.663C245.328,4.772,250.101,0,255.992,0c5.891,0,10.665,4.772,10.665,10.663V74.66C266.657,80.551,261.884,85.324,255.992,85.324z" />
        <path d="M277.337,63.997h-42.68c-5.89,0-10.663,4.773-10.663,10.664v234.656c0,5.89,4.773,10.671,10.663,10.671h42.68c5.874,0,10.655-4.781,10.655-10.671V74.66C287.992,68.77,283.211,63.997,277.337,63.997z" />
      </g>
    </svg>
  ),

  ChevronDown: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  ),
  Logo: ({ className, ...props }) => (
    <div 
      className={`inline-block ${className}`}
      {...props} 
      dangerouslySetInnerHTML={{ 
        __html: LOGO_SVG.replace('<svg', '<svg class="h-full w-auto" style="height: 100%; width: auto;"') 
      }} 
    />
  ),

  Settings: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),

  User: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  )
};

export default Icons;
